import classes from "./TableColumnTitles.module.css";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Fragment, useEffect, useRef, useState } from "react";
import readListUIStateFromIndexedDB from "../../../utils/cache/ListUiState/readListUIStateFromIndexedDB";
import storeListUIStateInIndexedDB from "../../../utils/cache/ListUiState/storeListUIStateInIndexedDB";
import MultiLanTxt from "../../UI/MultiLanTxt/MultiLanTxt";

const columnWidthSchema = {
  3: -82,
  5: -52,
  8: 40,
  12: 100,
  15: 110,
  18: 120,
  20: 120,
  23: 140,
};
const columnWidthCalc = (tableWidth, tableInfos) => {
  const visibleColumnsLength = tableInfos?.filter((which) => which?.show)?.length || 0;
  for (const [key, value] of Object.entries(columnWidthSchema)) {
    if (visibleColumnsLength <= key) return tableWidth / visibleColumnsLength + value;
  }
};

const TableColumnTitles = ({
  view,
  selectable = { selectable },
  userLanguage = "pe",
  sortNameHandler,
  sortIconName,
  tableInfos,
  selectAll,
  setSelectAll,
  selectAllRowsHandler,
  forceLtr,
  tableWidth,
  customWidth,
  persistKey,
  canSelectAll,
}) => {
  const [columnWidths, setColumnWidths] = useState([]);
  useEffect(() => {
    if (tableInfos?.length && columnWidths?.length === 0 && tableWidth) {
      const hydrate = async () => {
        try {
          const saved = await readListUIStateFromIndexedDB(persistKey || "List");
          const hasValidColumnWidthsInIndexDB = saved?.columnWidths && saved?.columnWidths.length > 0;

          if (hasValidColumnWidthsInIndexDB) {
            setColumnWidths(saved.columnWidths);
          } else {
            // console.log("tableWidth", tableWidth);
            setColumnWidths(
              tableInfos.map((each) => ({
                id: each.uniqueName,
                show: each.show,
                // width:customWidth ? customWidth : tableWidth / tableInfos?.filter((which) => which.show)?.length - 30,
                width: customWidth
                  ? customWidth
                  : Number(each?.initialWidth)
                    ? Number(each?.initialWidth)
                    : columnWidthCalc(tableWidth, tableInfos),
              })),
            );
            if (persistKey) {
              storeListUIStateInIndexedDB(persistKey, {
                columnWidths: tableInfos.map((each) => ({
                  id: each.uniqueName,
                  show: each.show,
                  // width:customWidth ? customWidth : tableWidth / tableInfos?.filter((which) => which.show)?.length - 30,
                  width: customWidth
                    ? customWidth
                    : Number(each?.initialWidth)
                      ? Number(each?.initialWidth)
                      : columnWidthCalc(tableWidth, tableInfos),
                })),
              });
            }
          }
        } catch (err) {
          console.error("Hydration in columnWidths failed:", err);
        }
      };

      hydrate();
    }
  }, [tableInfos, tableWidth]);

  const startXRef = useRef(null);
  const colIndexRef = useRef(null);
  const startWidthRef = useRef(null);
  // console.log("columnWidths", columnWidths);

  const handleMouseDown = (e, uniqueName) => {
    e.preventDefault();
    e.currentTarget.setPointerCapture(e.pointerId);
    startXRef.current = e.clientX;
    colIndexRef.current = uniqueName;
    startWidthRef.current = columnWidths.find((which) => which.id === uniqueName).width;
    document.addEventListener("pointermove", handleMouseMove);
    document.addEventListener("pointerup", handleMouseUp);
  };

  const handleMouseMove = (e) => {
    const diffX =
      forceLtr || userLanguage === "en" ? e.clientX - startXRef.current : startXRef.current - e.clientX;
    const newWidths = [...columnWidths];
    const colIndexRefIndex = newWidths.findIndex((which) => which.id === colIndexRef.current);
    const newWidth = {
      ...newWidths[colIndexRefIndex],
      width: Math.max(50, startWidthRef.current + diffX),
    };
    newWidths[colIndexRefIndex] = newWidth;
    setColumnWidths(newWidths);
    if (persistKey) {
      storeListUIStateInIndexedDB(persistKey, { columnWidths: newWidths });
    }
  };

  const handleMouseUp = () => {
    document.removeEventListener("pointermove", handleMouseMove);
    document.removeEventListener("pointerup", handleMouseUp);
  };

  return (
    <tr className={classes.headRow}>
      {selectable ? (
        <th className={classes.checkboxTitle}>
          {canSelectAll ? (
            <input
              type="checkbox"
              checked={selectAll}
              onChange={(e) => {
                setSelectAll(e.target.checked);
                selectAllRowsHandler(e.target.checked);
              }}
              className={classes.selectAllInput}
            />
          ) : null}
        </th>
      ) : null}
      <th className={classes.counterTitle} />
      {tableInfos
        .sort((a, b) => a.order - b.order)
        .map((inf, index) => (
          <Fragment key={index}>
            {inf.show ? (
              <th
                className={[
                  classes.thTitle,
                  // inf.field === "code" ? classes.codeTh : null,
                  /^is[A-Z]/.test(inf.field) ? classes.statusTh : null,
                ].join(" ")}
                style={{ width: columnWidths.find((which) => which.id === inf.uniqueName)?.width }}
              >
                <span className={userLanguage === "pe" ? classes.rtlThSort : classes.ltrThSort}>
                  <span className={classes.thSortTxt}>
                    {inf?.labelTid ? <MultiLanTxt tid={inf.labelTid} /> : inf.label}
                  </span>{" "}
                  <ArrowUpwardIcon
                    onClick={() => sortNameHandler(inf.uniqueName)}
                    className={[
                      classes.sortIcon,
                      sortIconName[inf.uniqueName] === "asc"
                        ? classes.sortIconAsc
                        : sortIconName[inf.uniqueName] === "desc"
                          ? classes.sortIconDesc
                          : null,
                    ].join(" ")}
                  />
                </span>
                {/* {index < tableInfos.filter((which) => which.show).length - 1 && ( */}
                <span
                  className={classes.resizeHandle}
                  onPointerDown={(e) => handleMouseDown(e, inf.uniqueName)}
                />
                {/* )} */}
              </th>
            ) : null}
          </Fragment>
        ))}
      {view ? null : (
        <th className={classes.thView}>
          <span style={{ width: "100%", minWidth: "80px" }} />
        </th>
      )}
    </tr>
  );
};

export default TableColumnTitles;
